import { Form, InputNumber } from 'antd';
import React from 'react';
import { NumUnicoProps } from './props';
import TitleFilter from '../TextFilter';

const SelectNumUnico: React.FC<NumUnicoProps> = ({ setNuNota }) => {
  const onChange = (values: any) => {
    setNuNota(values);
    localStorage.setItem(`nuNota${window.location.pathname}`, values);
  };

  return (
    <>
      <Form.Item label={<TitleFilter>Número único</TitleFilter>} name="nuNota">
        <InputNumber onChange={onChange} min={0} type="number" style={{ width: '100%' }} />
      </Form.Item>
    </>
  );
};

export default SelectNumUnico;
